import { Injectable } from '@angular/core';
import { ServiceBase } from './servicebase.service';
import { Observable, catchError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EtraceService extends ServiceBase {

  public matchFirearmETrace(ftsId: string, firearmId: string): Observable<ServerModels.FirearmETraceMatchViewModel[]> {
    let headersObj = this.httpOptions.headers.append('Skip-Loader', 'true');
    let options = {
      headers: headersObj,
      params: {
        'ftsId': ftsId,
        'firearmId': firearmId
      }
    }
    return this.http.get<ServerModels.FirearmETraceMatchViewModel[]>(`${this.apiRoot}/api/etrace/MatchFirearmETrace`, options).pipe(catchError(this.swallowError<any>('matchFirearmETrace', 'defaultMsg', null, null))); 
  }

  public confirmManualFTSID(etrace: ServerModels.ENESS_ETrace): Observable<number> {
    return this.http.post<ServerModels.ENESS_ETrace>(`${this.apiRoot}/api/etrace/AddTraceData`, etrace, this.httpOptions).pipe(catchError(this.swallowError<any>('confirmManualFTSID', 'defaultMsg', null, null))); 
  }

  public removeTraceData(firearmId: string, ftsId: string): Observable<number> {
    let headersObj = this.httpOptions.headers;
    let options = {
      headers: headersObj,
      params: {
        'ftsId': ftsId,
        'firearmId': firearmId
      }
    };
    return this.http.get<any>(`${this.apiRoot}/api/etrace/RemoveTraceData`, options).pipe(catchError(this.swallowError<any>('removeTraceData', 'defaultMsg', null, null))); 
  }
}
